import GlobalNavigationItem from './GlobalNavigationItem'
export default GlobalNavigationItem